import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const EventsServiceContext = createContext(undefined)

const EventsServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={EventsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/api/v1/events/events`, payload)
          return data
        },
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/events/events${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        get: async (id) => {
          const {data} = await axios.get(`/api/v1/events/events/${id}`)
          return data
        },
        update: async (id, payload) => {
          const {data} = await axios.patch(`/api/v1/events/events/${id}`, payload)
          return data
        },
        delete: async (id) => {
          const {data} = await axios.delete(`/api/v1/events/events/${id}`)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

EventsServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useEventsService = () => {
  const context = useContext(EventsServiceContext)
  if (context === undefined) {
    throw new Error('EventsServiceContext was not provided. Make sure your component is a child of the EventsServiceProvider.')
  }
  return context
}

const useEventsQuery = ({query, ...otherProps}) => {
  const eventsService = useEventsService()
  return useSimpleQuery({
    queryKey: `events-list-${JSON.stringify(query)}`,
    queryFn: async () => eventsService.list(query),
    ...otherProps
  })
}

const useEventQuery = ({id, enabled, ...otherProps}) => {
  const eventsService = useEventsService()
  return useSimpleQuery({
    queryKey: `events-get-${id}`,
    queryFn: async () => eventsService.get(id),
    enabled: enabled !== undefined ? enabled : !!id,
    ...otherProps
  })
}

export {EventsServiceProvider, useEventsService, useEventsQuery, useEventQuery}
